<template>
	<v-ons-page>
		<ons-toolbar>
			<div class="left"><ons-back-button></ons-back-button></div>
			<div class="center">{{title}}</div>
			<div class="right">
				<v-ons-toolbar-button slot="right" modifier="white-content" @click="openPdfDialog = true">
					<v-ons-icon icon="md-globe"></v-ons-icon>
				</v-ons-toolbar-button>
			</div>
		</ons-toolbar>
		<v-ons-alert-dialog modifier="rowfooter" :visible.sync="openPdfDialog">
			<span slot="title">Open in Browser?</span>
			<template slot="footer">
				<v-ons-alert-dialog-button @click="openPdfDialog = false">Cancel</v-ons-alert-dialog-button>
				<v-ons-alert-dialog-button @click="openPdfLink" >YES</v-ons-alert-dialog-button>
			</template>
		</v-ons-alert-dialog>
		<iframe class="qf-embed" :src="docLink"></iframe>
	</v-ons-page>
</template>

<script>
	export default {
		name: "SingleDocument",
		data() {
			return {
				link: null,
				openPdfDialog: false
			};
		},
		methods: {
			openPdfLink(){
				window.open(this.docLink, "_blank");
				this.openPdfDialog = false;
			}
		},
		mounted() {
			console.log("Single Attachment stuff: ", this);
		},
		computed: {
			docLink: function() {
				let token = this.$getCookie('access_token');
				if(token){
					if(this.eventAttachment){
						return	'https://api.thefoyer.ch/upload/event_file/'+this.id+'?access_token='+token
					}else{
						return 'https://api.thefoyer.ch/upload/entity_file/'+this.id+'?access_token='+token
					}
				}else{
					return false;
				}
			}
		},
	}
</script>

<style scoped>
	.content {
		overflow-y: auto;
		height: 100%;
	}
	.qf-embed {
		width: 100%;
		height: 100%;
		border: none;
		display: block;
	}
</style>
